"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Mail, MessageCircle,Phone } from "lucide-react";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import cooo from "../accests/common/cooo.jpg"

export default function ContactUS() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.name || !formData.email || !formData.message) {
            Swal.fire({
                title: "Error!",
                text: "Please fill all required fields.",
                icon: "error",
            });
            return;
        }

        const templateParams = {
            from_name: formData.name,    // matches {{from_name}} in template
            from_email: formData.email,  // matches {{from_email}}
            message: formData.message,   // matches {{message}}
        };

        emailjs
            .send(
                "service_qc3cxkm",    // Service ID
                "template_qha01ck",   // Template ID
                templateParams,
                "YHtrhzYxFL5ZNUv1k"  // Public Key
            )
            .then(() => {
                Swal.fire({
                    title: "Success!",
                    text: "Message sent successfully!",
                    icon: "success",
                });
                setFormData({ name: "", email: "", message: "" });
            })
            .catch((err) => {
                console.error("EmailJS Error:", err);
                Swal.fire({
                    title: "Error!",
                    text: "Failed to send message. Check console for details.",
                    icon: "error",
                });
            });
    };

    return (
        <div className="overflow-hidden bg-gray-50">
            {/* HERO */}
            <section className="relative h-80 flex items-center justify-center lg:mt-20">
                <img
                    src={cooo}
                    className="absolute inset-0 w-full h-full object-cover"
                    alt="Ranmali Tours"
                />
                <div className="absolute inset-0 bg-black/50"></div>
                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    className="relative text-4xl md:text-5xl font-bold text-white text-center"
                >
                    Contact Ranmali Tours
                </motion.h1>
            </section>

            {/* MAIN CONTENT */}
            <section className="max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-12 items-stretch">
                {/* MAP */}
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                    className="w-full h-full min-h-[600px] rounded-2xl overflow-hidden shadow-lg"
                >
                    <iframe
                        title="Ranmali Tours Location"
                        src="https://www.google.com/maps?q=53/3+Cemetery+Road+Randombe+Ambalangoda+Sri+Lanka&output=embed"
                        className="w-full h-full border-0"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </motion.div>

                {/* FORM + DETAILS */}
                <div className="flex flex-col justify-between space-y-10">

                    {/* CONTACT FORM */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="bg-white p-8 rounded-2xl shadow"
                    >
                        <h2 className="text-2xl font-bold text-center mb-6">
                            Send Us a Message
                        </h2>

                        <form className="grid gap-5" onSubmit={handleSubmit}>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Your Name"
                                className="border rounded-lg px-4 py-3 focus:ring-2 focus:ring-yellow-400 outline-none"
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Your Email"
                                className="border rounded-lg px-4 py-3 focus:ring-2 focus:ring-yellow-400 outline-none"
                                required
                            />
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="Your Message"
                                className="border rounded-lg px-4 py-3 h-32 focus:ring-2 focus:ring-yellow-400 outline-none"
                                required
                            />
                            <button
                                type="submit"
                                className="bg-yellow-400 text-white font-semibold py-3 rounded-full hover:scale-105 transition"
                            >
                                Send Message
                            </button>
                        </form>
                    </motion.div>

                    {/* CONTACT DETAILS */}
                    {/* CONTACT DETAILS */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="grid sm:grid-cols-2 gap-6"
                    >
                        <div className="bg-white p-6 rounded-xl shadow text-center hover:scale-105 transition">
                            <MapPin size={26} className="text-yellow-400 mx-auto mb-3" />
                            <h3 className="font-semibold">Our Address</h3>
                            <p className="text-gray-600 text-sm">
                                53/3, Cemetery Road,<br />
                                Randombe, Ambalangoda
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow text-center hover:scale-105 transition">
                            <Mail size={26} className="text-yellow-400 mx-auto mb-3" />
                            <h3 className="font-semibold">Email</h3>
                            <p className="text-gray-600">ranmalitours@gmail.com</p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow text-center hover:scale-105 transition">
                            <MessageCircle size={26} className="text-green-500 mx-auto mb-3" />
                            <h3 className="font-semibold">WhatsApp</h3>
                            <a
                                href="https://wa.me/+94770163670"
                                target="_blank"
                                className="text-green-500 font-semibold"
                            >
                                Chat Now
                            </a>
                        </div>

                        {/* PHONE NUMBER */}
                        <div className="bg-white p-6 rounded-xl shadow text-center hover:scale-105 transition">
                            <Phone size={26} className="text-yellow-400 mx-auto mb-3" />
                            <h3 className="font-semibold">Phone</h3>
                            <p className="text-gray-600">+94 77 016 3670</p>
                        </div>
                    </motion.div>


                </div>
            </section>
        </div>
    );
}
